import { useEffect, useState } from 'react';

function pad(n) {
  return String(n).padStart(2, '0');
}

export default function HeaderClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const h = pad(now.getHours());
  const m = pad(now.getMinutes());
  const s = pad(now.getSeconds());

  return (
    <div id="time" className="header-clock" aria-label={`${h}:${m}:${s}`}>
      <span className="hour">{h}</span>
      <span className="header-clock__sep" aria-hidden="true">:</span>
      <span className="minute">{m}</span>
      <span className="header-clock__sep" aria-hidden="true">:</span>
      <span className="second">{s}</span>
    </div>
  );
}
